module.exports = __webpack_public_path__ + "img/mailbox.658894f2.svg";